export const typography = {
  fontFamily: "'Plus Jakarta Sans', 'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  h1: { 
    fontSize: '2.375rem', 
    fontWeight: 700, 
    lineHeight: 1.2,
    letterSpacing: '-0.02em'
  },
  h2: { 
    fontSize: '1.875rem', 
    fontWeight: 700, 
    lineHeight: 1.3,
    letterSpacing: '-0.01em'
  },
  h3: { 
    fontSize: '1.625rem', 
    fontWeight: 600, 
    lineHeight: 1.4, 
    letterSpacing: '-0.005em'
  },
  h4: { 
    fontSize: '1.375rem', 
    fontWeight: 600, 
    lineHeight: 1.4,
    letterSpacing: '0em'
  },
  h5: { 
    fontSize: '1.125rem', 
    fontWeight: 600, 
    lineHeight: 1.5,
    letterSpacing: '0em'
  },
  h6: { 
    fontSize: '0.875rem', 
    fontWeight: 600, 
    lineHeight: 1.6,
    letterSpacing: '0em'
  },
  body1: { 
    fontSize: '0.813rem', 
    fontWeight: 400, 
    lineHeight: 1.6,
    letterSpacing: '0em'
  },
  body2: { 
    fontSize: '0.688rem', 
    fontWeight: 400, 
    lineHeight: 1.5,
    letterSpacing: '0em'
  },
  caption: { 
    fontSize: '0.625rem', 
    fontWeight: 500, 
    lineHeight: 1.5,
    letterSpacing: '0.01em'
  },
  button: {
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: 1.75,
    letterSpacing: '0.02857em',
    textTransform: 'uppercase'
  },
  overline: {
    fontSize: '0.625rem',
    fontWeight: 400,
    lineHeight: 2.66,
    letterSpacing: '0.08333em',
    textTransform: 'uppercase'
  }
};

export default typography;
